import React from 'react';
import AlphabetPuzzle from './AlphabetPuzzle';

const AlphabetA = () => {
  return (
    <AlphabetPuzzle
      letter="A"
      word="Apple"
      imageSrc="/assets/images/a-apple.jpg"
    />
  );
};

export default AlphabetA;
